/**
 * Open Trader legs sharing the same sport + match_id count as one in-play "game"
 * (matches backend `countDistinctActiveTradeMatches`).
 */
export function countDistinctActiveTradeMatches(trades: unknown[]): number {
    if (!Array.isArray(trades) || trades.length === 0) return 0;
    const keys = new Set<string>();
    let anon = 0;
    for (const raw of trades) {
        if (!raw || typeof raw !== "object") continue;
        const t = raw as Record<string, unknown>;
        const sport = String(t.sport ?? "")
            .trim()
            .toUpperCase() || "UNKNOWN";
        const mid = String(t.match_id ?? "").trim();
        const id = t.id != null && t.id !== "" ? String(t.id) : "";
        const key = mid ? `${sport}|m:${mid}` : `${sport}|t:${id || `n:${anon++}`}`;
        keys.add(key);
    }
    return keys.size;
}
